import { Menu } from '@/components/menu/types';
import { FfbbsiteNavigationsItems, FfbbsitePages } from '../directus';

const customInternalPages = ['live', 'jouer'];

export default function mapNavitationItemsToMenuUrl(
  menuItems: FfbbsiteNavigationsItems[],
): Array<Menu> {
  return menuItems.map(({ children, label, open_in_new_tab, page, title, type, url }) => {
    let urlInfo = url || '';
    let slug = '';
    let external = open_in_new_tab;
    if (!external) {
      external = false;
    }
    const pageInfo = page as FfbbsitePages;
    if (type === 'page' && pageInfo) {
      const pagePermalink = pageInfo.permalink || '';

      urlInfo = '/';
      slug = pagePermalink;
      if (customInternalPages.includes(pagePermalink)) {
        urlInfo = `/${pagePermalink}`;
        slug = '';
      }
    } else if (type === 'url') {
      urlInfo = url || '';
    }

    return {
      label: label || title || '',
      url: {
        url: urlInfo,
        external,
        slug,
      },
      children: children ? mapNavitationItemsToMenuUrl(children) : [],
    };
  });
}
